<template>
    <ul :class="ul_class">
        <li v-if="!footer.ocultar_afiliados" @click="closeMenu">
            <router-link
                :to="{ name: 'front.afiliados.index' }"
                :class="btn_class"
            >
                {{ $t('header.afiliados') }}
            </router-link>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !esBenidormNext" @click="closeMenu">
            <router-link
                :to="!is_logged ? { name: 'login' } : { name: 'perfil' }"
                :class="btn_class"
            >
                {{ $t('header.liberar_asiento') }}
            </router-link>
        </li>
        <li v-if="!footer.ocultar_acreditaciones" @click="closeMenu">
            <router-link
                v-if="footer.activar_acreditaciones"
                :to="{ name: 'front.acreditacion' }"
                :class="btn_class"
            >
                {{ $t('header.acreditacion') }}
            </router-link>
            <del v-else>{{ $t('header.acreditacion') }}</del>
        </li>
        <li v-if="!footer.ocultar_parcelas && lista.activar_parcelas" @click="closeMenu">
            <router-link
                v-if="footer.activar_parcelas"
                :to="{ name: 'front.parcelas' }"
                :class="btn_class"
            >
                {{ $t('home.parcelas') }}
            </router-link>
            <del v-else>{{ $t('home.parcelas') }}</del>
        </li>
        <li v-if="!footer.ocultar_pack" @click="closeMenu">
            <router-link
                v-if="footer.activar_pack"
                :to="{ name: 'front.packs.index' }"
                :class="btn_class"
            >
                {{ $t('header.packs') }}
            </router-link>
            <del v-if="!footer.activar_pack">{{ $t('header.packs') }}</del>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !footer.ocultar_experiencias" @click="closeMenu">
            <router-link
                v-if="footer.activar_experiencias"
                :to="{ name: 'front.experiencias.index' }"
                :class="btn_class"
            >
                {{teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? $t('header.experiencias') : 'FUTSAL FEST' }}
            </router-link>

            <del v-else>{{ teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? $t('header.experiencias') : 'FUTSAL FEST'  }}</del>
        </li>
        <li v-if="!footer.ocultar_productos" @click="closeMenu">
            <router-link
                v-if="footer.activar_productos"
                :to="{ name: 'front.productos.index' }"
                :class="btn_class"
            >
                {{ $t('productos.productos') }}
            </router-link>
            <del v-else>{{ $t('productos.productos') }}</del>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !footer.ocultar_futbol_base" @click="closeMenu">
            <router-link
                v-if="footer.futbol_base"
                :to="{ name: 'front.bases.index' }"
                :class="btn_class"
            >
                {{ $t('header.cantera') }}
            </router-link>

            <del v-else> {{ $t('header.cantera') }} </del>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !footer.ocultar_renovacion_futbol_base" @click="closeMenu">
            <router-link
                v-if="footer.renovacion_futbol_base"
                :to="{ name: 'front.bases.renovar' }"
                :class="btn_class"
            >
                {{ $t('header.renovar_cantera') }}
            </router-link>

            <del v-else> {{ $t('header.renovar_cantera') }} </del>
        </li>
        <li v-if="!footer.ocultar_renovar_abono" @click="closeMenu">
            <router-link
                v-if="footer.renovar_abono"
                :to="{ name: 'front.abonos.renovar.index' }"
                :class="btn_class"
            >
                {{ $t('header.renovar' , {abono: teatro.texto_abono}) }}
            </router-link>

            <del v-else>{{ $t('header.renovar' , {abono: teatro.texto_abono}) }}</del>
        </li>
        <li v-if="!footer.ocultar_abonos" @click="closeMenu">
            <router-link
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.abonos.nuevo.index' }"
                :class="btn_class"
            >
                {{ etiquetaNuevoAbono }}
            </router-link>

            <del v-else> {{ etiquetaNuevoAbono }}</del>
        </li>
        <li hidden="true" v-if="false" @click="closeMenu">
            <router-link
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.bases.crear' }"
                :class="btn_class"
            >
                Inscribir base
            </router-link>

            <del v-else>Inscribir base</del>
        </li>
        <li v-if="false" @click="closeMenu">
            <router-link
                v-if="footer.venta_simpatizantes"
                :to="{ name: 'front.simpatizantes.index' }"
                :class="btn_class"
            >
                {{ configuracion.simpatizantes }}
            </router-link>

            <del v-else>{{ configuracion.simpatizantes }}</del>
        </li>

        <li v-if="!footer.ocultar_eventos" @click="closeMenu">
            <router-link
                v-if="footer.partidos"
                :to="{ name: 'front.eventos.index' }"
                :class="btn_class"
            >
                <template v-if="footer.tipo == config.DEPORTES">
                    {{ $t('header.partidos') }}
                </template>
                <template v-else>
                    {{ $t('header.eventos') }}
                </template>
            </router-link>

            <del v-else>
                <template v-if="footer.tipo == config.DEPORTES">
                    {{ $t('header.partidos') }}
                </template>
                <template v-else>
                    {{ $t('header.eventos') }}
                </template>
            </del>
        </li>
        <li v-if="is_logged && user && user.tipo == 'user'" @click="closeMenu">
            <router-link
                :to="{ name: 'perfil' }"
                class="gradient-color"
                :class="btn_class"
            >{{ $t('header.perfil') }}</router-link>
        </li>
        <li v-if="is_logged && user && user.tipo != 'user'" @click="closeMenu">
            <router-link
                :to="'/admin'"
                :class="btn_class"
            >
                {{ $t('header.administracion') }}
            </router-link>
        </li>
        <li v-if="footer.lfp === 1 && teatro.sga === 0" @click="closeMenu">
            <router-link
                :to="{ name: 'mi-abono' }"
                :class="btn_class"
            >
                {{ $t('header.mi_abono')}}
            </router-link>
        </li>
        <li v-if="teatro.sga == 1" @click="closeMenu">
            <router-link
                :to="{ name: 'front.abonos.buscar-abonado' }"
                :class="btn_class"
            >
                {{ $t('header.buscar') }}
            </router-link>
        </li>
        <li @click="closeMenu">
            <router-link
                :to="{ name: 'ayuda' }"
                :class="btn_class"
            >
                {{ $t('header.ayuda') }}
            </router-link>
        </li>
        <li v-if="!is_logged" @click="closeMenu">
            <router-link
                :to="{ name: 'login' }"
                :class="btn_class"
            >
                {{ $t('header.login') }}
            </router-link>
        </li>
        <li v-else @click="closeMenu">
            <a
                href="#"
                @click="logout"
                :class="btn_class"
            >
                {{ $t('header.cerrar_sesion') }}
            </a>
        </li>
    </ul>
</template>

<script setup>
    import { computed, getCurrentInstance, onMounted } from 'vue';
    import store from '@/store';
    import { TEATRO_HASH_CF_BENIDORM_NEXT, TEATRO_HASH_LA_MAR_DE_MUSICAS } from '@/constants/teatros';

    const esBenidormNext = computed(() => store.getters.getConfig?.hash_teatro === TEATRO_HASH_CF_BENIDORM_NEXT);
    import { useRouter } from '@/composables/common/router/useRouter';
    import { config } from '@/config.js';

    const props = defineProps({
        btn_class: String,
        footer: Object,
        configuracion: Object,
        ul_class: String
    });

    const emit = defineEmits(['closeMenu']);

    const router = useRouter();

    const is_logged = computed(() => store.getters.isLogged);
    const user = computed(() => store.getters.getUser);
    const lista = computed(() => store.getters.getListaAbonados);
    const teatro = computed(() => store.getters.getTeatro);

    // En <script setup> no hay `this.$t`: se guarda el proxy al montar el setup,
    // que es el único momento en que getCurrentInstance() lo devuelve.
    const proxy = getCurrentInstance().proxy;

    const etiquetaNuevoAbono = computed(() => {
        // Primero los textos propios de cada teatro: si uno quiere el suyo, no
        // debe quedar tapado por el botón configurado en la lista.
        if (teatro.value?.hash === TEATRO_HASH_LA_MAR_DE_MUSICAS) return proxy.$t('home.nuevo_abono_lamardemusicas');
        if (teatro.value?.hash === '8IuCwC47T9n0qgn2ky0G') {
            return proxy.$t('home.nuevo_abono_talavera', { abono: teatro.value?.texto_abono.toUpperCase() });
        }
        // Penúltimo: el botón que el teatro haya configurado en su lista.
        if (lista.value?.btn_nuevo_abono) return lista.value.btn_nuevo_abono;

        return proxy.$t('home.nuevo_abono', { abono: teatro.value?.texto_abono });
    });

    const logout = () => {
        store.dispatch('logout', { router });
    };

    const closeMenu = () => {
        emit('closeMenu');
    };

    onMounted(() => {
        const totalLi = document.querySelectorAll('#aside ul.menu li').length;

        if (totalLi > 10) {
            const style = document.createElement('style');
            style.setAttribute('id', 'more-than-10');
            style.innerHTML = `
                #aside ul.menu {
                    padding: 0px 0 0px !important;
                }
                #aside ul.menu > li > a,
                #aside ul.menu > li > del {
                    font-size: 18px !important;
                }
            `;
            document.head.appendChild(style);
        }
    });
</script>

<style scoped>
    ul li {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        float: center;
        margin-bottom: 12px;
        font-size: 1.125rem;
        z-index: 999 !important;
    }

    #aside ul.menu {
        padding: 50px 0 20px;
    }

    @media (min-width: 376px) {
        ul li {
            margin-bottom: 15px;
            font-size: 1.3rem;
        }
    }
</style>
